import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'auto_details.my_offers.title',
  },
  subTitle: {
    id: 'auto_details.my_offers.sub_title',
  },
  body: {
    id: 'auto_details.my_offers.body',
  },
  action: {
    id: 'auto_details.my_offers.action',
  },
});
